import http from "../../http-common";

export default class RevisionHistoryService {

    // ==================== ADD REVISION ====================
    static addRevision(versionId, data) {
        return http.post(`/revisions/create/${versionId}`, data);
    }

    // ==================== GET REVISION HISTORY ====================
    static getRevisionHistory(versionId, documentType = "tag_data_pdf") {
        return http.get(`/revisions/get/${versionId}`, {
            params: { document_type: documentType }
        });
    }

    // ==================== UPDATE REVISION ====================
    static updateRevision(revisionId, data) {

        if (revisionId) {
            return http.put(
                `/revisions/update/${revisionId}`,
                data
            );
        }

        return http.put(
            `/revisions/update`,
            data
        );
    }

    // ==================== DELETE REVISION ====================
    static deleteRevision(revisionId) {
        return http.delete(`/revisions/delete/${revisionId}`);
    }
}